module.exports = __webpack_public_path__ + "img/DSC_2837-xs.18988cf6.png";